import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerForm from "@/pages/CustomerForm";
import CustomerDetail from "@/pages/CustomerDetail";
import Reports from "@/pages/Reports";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/musteriler" element={<Customers />} />
            <Route path="/musteriler/yeni" element={<CustomerForm />} />
            <Route path="/musteriler/:id" element={<CustomerDetail />} />
            <Route path="/musteriler/:id/duzenle" element={<CustomerForm />} />
            <Route path="/raporlar" element={<Reports />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
